import {sparkleSvg as Icon__small__sparkleSvg} from '../Icon__small/Icon__small--sparkle.js';

export var sparkle = {
  name: 'sparkle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__sparkleSvg,
};
